import AvailabilityTable from '../AvailabilityTable';
import styled from 'styled-components';

const BoatBlock = () => (
    <Container>
        <AvailabilityTable />
    </Container>
);

const Container = styled.div`
    margin: 4rem 0 4rem 0;

    h1 {
        margin-bottom: 3rem;
    }
`;

export default BoatBlock;
